import { Navigate } from "react-router-dom";
import { routePath } from "./Pipes";

export const SubRoute = ({ children, enableDirectAccess = false }) => {
  const defaultRoute = routePath("simulatore");

  const canRouteTo = () => {
    return true === window.hasRoot || enableDirectAccess;
  };

  return canRouteTo() ? children : <Navigate to={defaultRoute} />;
};

export const storeSync = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSync = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch (error) {
    console.error(error);
    return null;
  }
};
